import React from 'react';
import { useSEO } from '@/hooks/useSEO';
import { useLanguage } from '@/contexts/LanguageContext';

const HEADER_IMG = 'https://images.unsplash.com/photo-1567684014761-b65e2e59b9eb?w=2000&q=80&auto=format&fit=crop';

const PageHero = ({ title, image }) => (
  <section className="relative min-h-[70vh] w-full overflow-hidden flex items-end" data-testid="page-hero">
    <div className="absolute inset-0 bg-cover bg-center anim-scale-out" style={{ backgroundImage: `url(${image})` }} />
    <div className="absolute inset-0 hero-overlay" />
    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-24 w-full">
      <h1 className="anim-fade-up delay-300 font-serif font-light text-white text-5xl sm:text-6xl lg:text-7xl tracking-tighter max-w-4xl leading-[1.05]">
        {title}
      </h1>
    </div>
  </section>
);

const About = () => {
  const { t } = useLanguage();
  useSEO({ title: 'Apie mus — UAB MAIŠIAGALA GROUP', description: 'Sužinokite apie MAIŠIAGALA GROUP — misija, vertybės, plėtros strategija ir įmonės istorija.', path: '/about' });
  const values = t('about.values') || [];
  return (
    <div data-testid="about-page">
      <PageHero title={t('about.title')} image={HEADER_IMG} />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 space-y-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <h2 className="font-serif text-white text-3xl sm:text-4xl tracking-tight">{t('about.mission_title')}</h2>
          </div>
          <p className="md:col-span-8 text-white/70 text-lg leading-relaxed">{t('about.mission_body')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-[#262626] pt-24">
          <div className="md:col-span-4">
            <h2 className="font-serif text-white text-3xl sm:text-4xl tracking-tight">{t('about.values_title')}</h2>
          </div>
          <ul className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-x-12 gap-y-6">
            {values.map((v, i) => (
              <li key={i} className="border-b border-[#262626] pb-4 flex items-center gap-4" data-testid={`value-${i}`}>
                <span className="text-gold font-serif text-2xl">0{i + 1}</span>
                <span className="text-white text-lg font-serif tracking-tight">{v}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-[#262626] pt-24">
          <div className="md:col-span-4">
            <h2 className="font-serif text-white text-3xl sm:text-4xl tracking-tight">{t('about.strategy_title')}</h2>
          </div>
          <p className="md:col-span-8 text-white/70 text-lg leading-relaxed">{t('about.strategy_body')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-[#262626] pt-24">
          <div className="md:col-span-4">
            <h2 className="font-serif text-white text-3xl sm:text-4xl tracking-tight">{t('about.history_title')}</h2>
          </div>
          <p className="md:col-span-8 text-white/70 text-lg leading-relaxed">{t('about.history_body')}</p>
        </div>

        {/* Property photos */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#262626] border-t border-[#262626] pt-px">
          <img src="https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=2000&q=80&auto=format&fit=crop" alt="Modernus skandinaviško stiliaus privatus namas su dideliais langais ir žaliais sodais" className="w-full aspect-[4/3] object-cover"  loading="lazy" />
          <img src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=2000&q=80&auto=format&fit=crop" alt="Šiuolaikinis lietuviško stiliaus 2 aukštų gyvenamasis namas su mediniais akcentais ir natūralia aplinka" className="w-full aspect-[4/3] object-cover"  loading="lazy" />
        </div>
      </section>
    </div>
  );
};

export default About;
export { PageHero };
